import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faFileAlt,
  faShieldAlt,
} from '@fortawesome/free-solid-svg-icons';
import { apiDownloadDocument, documentMethodManualUpload } from '../../services/axios-client/axeCommons';
import { getCommercialCompletedData, commercialCompletedDataReset } from '../../features/purchases/purchasesActions';
import PageLoading from '../../common/componentsV2/elements/PageLoading';
import ErrorComponent from '../../common/components/ErrorComponent';
import { CommercialCompletedScreenStyles } from './completedScreens.styles';
import {
  CompletedCard,
  CompletedCardHeader,
  CompletedCardIcon,
  CompletedCardTitle,
  CompletedFieldGrid,
  CompletedField,
  CompletedSectionTitle,
} from './CompletedV2.styles';
// import CompletedQuoteScreenAutoAfterSale from '../../common/components/elements/CompletedQuoteScreenAutoAfterSale';
import TutelaLegaleInfoModal from '../../common/components/redesignComponents/Modal/TutelaLegaleInfoModal';
import pdfIMG from '../../assets/images/purchase/pdf.png';
import downloadIMG from '../../assets/redesign_icons/download.svg';
import uploadIcon from '../../assets/redesign_icons/upload.svg';
import { ActionsWrapperResultPage } from '../../common/components/redesignComponents/Purchase/SignatureType.styles';
import {
  generalAlertError,
} from '../../common/utils/alerts';
import { sonnerSuccessAlert } from '../../common/utils/sonnerAlerts';
import CompletedQuoteScreenInfoCommercial from '../../common/components/elements/CompletedQuoteScreenInfoCommercial';
import ContractDocuments from '../../common/components/elements/ContractDocuments';
import CompletedQuoteScreenAutoAfterSale from '../../common/components/elements/CompletedQuoteScreenAutoAfterSale';
import CompletedScreenSemestraleButton from '../../common/components/elements/CompletedScreenSemestraleButton';
import CompletedScreenCustomerLinkButton from '../../common/components/elements/CompletedScreenCustomerLinkButton';
import axe from '../../services/axios-client/axiosClient';
import { downloadFile } from '../../services/axios-client/axeHelpers';

function CommercialCompletedScreen() {
  const { quoteId } = useParams();
  const [showModal, setShowModal] = useState(false);
  const { loading, quote, error } = useSelector((store) => store.purchases.commercial_completed);
  const { document_types } = useSelector(
    (store) => store.afterSale,
  );
  const navigate = useNavigate();

  const uploadPolizzaEmessa = useRef(null); // 13 - Polizza emessa
  const uploadQuietanzaSemestrale = useRef(null); // 32 - Quietanza Semestrale
  const uploadPrivacyRef = useRef(null); // 12 - Privacy Greenia
  const uploadPreContractRef = useRef(null); // 29 - Percontrattuale Greenia
  const uploadDichiarazioniDocRef = useRef(null); // 28 - Dichiarazioni del contraente
  const uploadQuestionarioAutoDocRef = useRef(null); // 30 - Questionario Auto
  const uploadTutelaLegaleRef = useRef(null); // 19 - Tutela Legale
  const uploadQuestionarioProfessioneRef = useRef(null); // 33 - Questionario Ptofesionale
  const uploadMergedDocFileRef = useRef(null); // 34 - Merged Files

  const fireSignedDocUpload = (typeId) => {
    if ([13, 35].includes(typeId)) {
      uploadPolizzaEmessa.current.click();
    }
    if (typeId === 32) {
      uploadQuietanzaSemestrale.current.click();
    }
    if (typeId === 29) {
      uploadPreContractRef.current.click();
    }

    if (typeId === 12) {
      uploadPrivacyRef.current.click();
    }

    if (typeId === 28) {
      uploadDichiarazioniDocRef.current.click();
    }

    if (typeId === 30) {
      uploadQuestionarioAutoDocRef.current.click();
    }

    if (typeId === 19) {
      uploadTutelaLegaleRef.current.click();
    }

    if (typeId === 33) {
      uploadQuestionarioProfessioneRef.current.click();
    }

    if (typeId === 34) {
      uploadMergedDocFileRef.current.click();
    }
  };

  const collectQuoteData = () => {
    getCommercialCompletedData(quoteId);
  };

  const uploadSignedDocument = async (documentId, files) => {
    const uploadedFile = files[0];
    const reader = new FileReader();

    reader.readAsDataURL(uploadedFile);
    if (uploadedFile.type !== 'application/pdf') {
      generalAlertError('Formato di file errato. Il file deve essere in .pdf');
      return;
    }
    reader.onload = () => {
      documentMethodManualUpload(quote.id, documentId, {
        document: reader.result.replace('data:application/pdf;base64,', ''),
      }).then(() => {
        collectQuoteData();
        sonnerSuccessAlert('File caricato');
      });
    };
  };

  const downloadDocument = async (documentId) => {
    const response = await apiDownloadDocument(documentId);
    const alink = document.createElement('a');
    alink.target = '_blank';
    alink.href = response.data.data.contents;
    alink.download = response.data.data.filename;
    alink.click();
  };

  useEffect(() => {
    collectQuoteData();

    return () => {
      commercialCompletedDataReset();
    };
  }, [quoteId]);

  if (loading) {
    return <PageLoading />;
  }

  if (loading === false && error !== null) {
    return <ErrorComponent error={error} />;
  }

  const documents = [
    ...quote.insurance_request.documents,
    ...quote.documents,
  ];

  // const documentsRequests = [
  //   ...quote.insurance_request.document_requests.filter(
  //     (dr) => dr.document !== null,
  //   ),
  //   ...quote.document_requests.filter((dr) => dr.document !== null),
  // ];

  // const downloadOptionalDocument = async (documentId) => {
  //   const response = await apiDownloadOptionalDocument(documentId);
  //   const alink = document.createElement('a');
  //   alink.target = '_blank';
  //   alink.href = response.data.data.contents;
  //   alink.download = response.data.data.filename;
  //   alink.click();
  // };

  const downloadInvoice = async (quoteId, payment_number) => {
    const res = await axe.get(`/list/invoices/${quoteId}/download/${payment_number}`, {
      responseType: 'blob',
    });
    const contentDisposition = res.headers['content-disposition'];
    const file_name = contentDisposition.split('filename="')[1].split('"')[0];
    downloadFile(res.data, file_name);
  };

  return (
    <>
      {showModal && (
        <TutelaLegaleInfoModal
          quotation={{
            product_name: quote.risk_information.product_name,
            massimale: quote.risk_information.massimale,
            amount: quote.amount,
            tax_total: quote.tax_total,
            information: quote.risk_information.information,
          }}
          setShowModal={setShowModal}
        />
      )}
      <CommercialCompletedScreenStyles>
        {quote.payments.length === 1 && quote.status === 4 && quote.payment_frequency === 2 && (
          <CompletedScreenSemestraleButton
            onNavigate={() => navigate(`/quotes/offline/purchase/${quote.insurance_request.request_token}`)}
            buttonText="Procedi al pagamento"
            disabled={false}
            v2
          />
        )}
        {quote.status === 7 && quote.insurance_request.active_customer_id && (
          <CompletedScreenCustomerLinkButton
            onNavigate={() => {
              navigate(`/clients/${quote.insurance_request.active_customer_id}`);
            }}
            buttonText="Apri dettaglio cliente"
            disabled={false}
            v2
          />
        )}
        {/* Contract Documents Section */}
        <div className="section-container">
          <ContractDocuments
            downloadDocument={downloadDocument}
            insuranceRequest={quote.insurance_request}
            quote={quote}
            collectQuoteData={collectQuoteData}
            v2
          />
        </div>

        {/* Customer Information Section */}
        <div className="section-container">
          <CompletedSectionTitle>
            <FontAwesomeIcon icon={faFileAlt} className="section-icon" />
            <h2>Informazioni Polizza</h2>
          </CompletedSectionTitle>

          <div className="cards-row">
            {/* Anagrafica Card */}
            <div>
              <CompletedCard className="polizze-emessa-status-step-one">
                <CompletedCardHeader>
                  <CompletedCardIcon>
                    <FontAwesomeIcon icon={faBuilding} />
                  </CompletedCardIcon>
                  <CompletedCardTitle>Anagrafica</CompletedCardTitle>
                </CompletedCardHeader>

                <CompletedFieldGrid>
                  <CompletedField className="full">
                    <dt>Nome Compagnia</dt>
                    <dd>
                      {quote.insurance_request.customer ? quote.insurance_request.customer.business_name : quote.insurance_request.commercial_company.business_name}
                    </dd>
                  </CompletedField>

                  <CompletedField className="full">
                    <dt>Attività</dt>
                    <dd>
                      {quote.insurance_request?.commercial_company?.activity_description ?? '-'}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Numero Compagnia</dt>
                    <dd>
                      {quote.insurance_request?.commercial_company?.company_number}
                    </dd>
                  </CompletedField>

                  <CompletedField>
                    <dt>Partita IVA</dt>
                    <dd>
                      {quote.insurance_request.customer ? quote.insurance_request.customer.vat_number : quote.insurance_request.commercial_company.vat_number}
                    </dd>
                  </CompletedField>

                  <CompletedField className="full">
                    <dt>Indirizzo</dt>
                    <dd>
                      {quote.insurance_request.customer
                        ? quote.insurance_request.customer.address
                        : quote.insurance_request.commercial_company.alter_summary_address}
                    </dd>
                  </CompletedField>
                </CompletedFieldGrid>
              </CompletedCard>
            </div>
          </div>
        </div>

        {/* Quote Details & Documents Section */}
        <div className="section-container">
          <CompletedSectionTitle>
            <FontAwesomeIcon icon={faShieldAlt} className="section-icon" />
            <h2>Dettagli Preventivo e Documenti</h2>
          </CompletedSectionTitle>

          <div className="row">
            <CompletedQuoteScreenInfoCommercial
              rc_quotation={quote}
              risk_quotations={quote.risk_quotations}
            />
          </div>

          <CompletedCard className="polizze-emessa-status-step-four">
            <CompletedCardHeader>
              <CompletedCardIcon>
                <FontAwesomeIcon icon={faFileAlt} />
              </CompletedCardIcon>
              <CompletedCardTitle>Documenti</CompletedCardTitle>
            </CompletedCardHeader>
            <div className="documents-body">
              <ul className="documents-list">
                {documents.filter(
                  (dr) => dr.document_type_id !== 34 && dr.document_type_id !== 35 && dr.document_type_id !== 36
                    && dr.document_type_id !== 37 && dr.document_type_id !== 38
                    && dr.document_type_id !== 39 && dr.document_type_id !== 40
                    && dr.document_type_id !== 41,
                )
                  .map((document, index) => (
                    <li
                      className="document-item"
                      key={index}
                    >
                      <div className="document-content flex-column">
                        <div className="document-name">
                          {document.document_type.name}
                        </div>
                        <div className="document-actions flex-row">
                          <div className="file-info">
                            <img
                              src={pdfIMG}
                              className="img-fluid"
                              width="25"
                              alt="PDF"
                            />
                            <span className="file-name">
                              {document.original_filename}
                            </span>
                          </div>
                          <button
                            className="doc-btn border-0 bg-transparent"
                            onClick={() => downloadDocument(document.id)}
                          >
                            <img src={downloadIMG} width="25" alt="Scarica" />
                          </button>
                          {document.signable_document === 1
                            && (document.is_signed_valid === 0
                              || (document.is_signed_valid === null
                                && document.signed_document_filename === null)) && (
                                <ActionsWrapperResultPage>
                                  {' '}
                                  {[13, 35].includes(document.document_type.id) && (
                                  <div
                                    className="action-button"
                                    onClick={() => fireSignedDocUpload(document.document_type_id)}
                                  >
                                    <img src={uploadIcon} alt="" width={25} />
                                    <input
                                      ref={uploadPolizzaEmessa}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 32 && (
                                  <div
                                    className="action-button"
                                    onClick={() => fireSignedDocUpload(document.document_type_id)}
                                  >
                                    <img src={uploadIcon} alt="" width={25} />
                                    <input
                                      ref={uploadQuietanzaSemestrale}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 29 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadPreContractRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 28 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadDichiarazioniDocRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 30 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadQuestionarioAutoDocRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 34 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadMergedDocFileRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 12 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadPrivacyRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 19 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadTutelaLegaleRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                  {document.document_type.id === 33 && (
                                  <div
                                    className="action-button"
                                    onClick={
                                      document.signed_document_filename === null
                                        ? () => fireSignedDocUpload(
                                          document.document_type.id,
                                        )
                                        : () => { }
                                    }
                                  >
                                    <img src={uploadIcon} alt="Carica" width={25} />
                                    <input
                                      ref={uploadQuestionarioProfessioneRef}
                                      type="file"
                                      name=""
                                      id=""
                                      className="d-none"
                                      onChange={(e) => uploadSignedDocument(
                                        document.id,
                                        e.target.files,
                                      )}
                                    />
                                  </div>
                                  )}
                                </ActionsWrapperResultPage>
                          )}
                        </div>
                        {document.signable_document === 1
                          && document.is_signed_valid === 0
                          && document.signed_document_filename === null
                          && document.motivation !== null && (
                            <p className="document-motivation">
                              {document.motivation}
                            </p>
                        )}
                      </div>
                      <div className="document-status">
                        {document.signable_document === 1 ? (
                          document.is_signed_valid === null
                            && document.signed_document_filename !== null ? (
                              <span className="status-badge status-warning">
                                In Verifica
                              </span>
                            ) : document.is_signed_valid === 0 ? (
                              <span className="status-badge status-danger">
                                Firma Non Valida
                              </span>
                            ) : document.is_signed_valid === null
                            && document.signed_document_filename === null ? (
                              <span className="status-badge status-warning">
                                Da Firmare
                              </span>
                              ) : document.is_signed_valid === 1
                            && document.signed_document_filename !== null ? (
                              <span className="status-badge status-success">
                                Firmato
                              </span>
                                ) : null
                        ) : (
                          <span className="status-badge status-info">
                            Non Richiede Firma
                          </span>
                        )}
                      </div>
                    </li>
                  ))}
                <li className="document-item">
                  <div className="document-content flex-column gap-0">
                    <div className="document-name">
                      Fattura
                    </div>
                    <div className="document-actions flex-row">
                      <div className="file-info">
                        <img
                          src={pdfIMG}
                          className="img-fluid"
                          width="25"
                          alt="PDF"
                        />
                        <span className="file-name">Scarica Fattura</span>
                      </div>
                      <button
                        className="doc-btn border-0 bg-transparent"
                        onClick={() => downloadInvoice(quote.id)}
                      >
                        <img src={downloadIMG} width="25" alt="Scarica" />
                      </button>
                    </div>
                  </div>
                  <div className="document-status">
                    <span className="status-badge status-info">
                      Non Richiede Firma
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </CompletedCard>

          {quote.initial_quotation !== undefined && (
            <CompletedCard className="mt-3">
              <CompletedCardHeader>
                <CompletedCardIcon>
                  <FontAwesomeIcon icon={faFileAlt} />
                </CompletedCardIcon>
                <CompletedCardTitle>Documenti nel preventivo iniziale</CompletedCardTitle>
              </CompletedCardHeader>
              <div className="documents-body">
                <ul className="documents-list">
                  {quote.initial_quotation.insurance_request.documents.map(
                    (document, index) => (
                      <li
                        className="document-item"
                        key={index}
                      >
                        <div className="document-content">
                          <div className="document-name">
                            {document.document_type.name}
                          </div>
                          <div className="document-actions">
                            <div className="file-info">
                              <img
                                src={pdfIMG}
                                className="img-fluid"
                                width="25"
                                alt="PDF"
                              />
                              <span className="file-name">
                                {document.original_filename}
                              </span>
                            </div>
                            <button
                              className="doc-btn border-0 bg-transparent"
                              onClick={() => downloadDocument(document.id)}
                            >
                              <img src={downloadIMG} width="25" alt="Scarica" />
                            </button>
                          </div>
                        </div>
                        <div className="document-status">
                          {document.signable_document === 1
                            && document.is_signed_valid ? (
                              <span className="status-badge status-success">
                                Firmato
                              </span>
                            ) : (
                              <span className="status-badge status-info">
                                Non Richiede Firma
                              </span>
                            )}
                        </div>
                      </li>
                    ),
                  )}
                  {quote.initial_quotation.documents.map((document, index) => (
                    <li
                      className="document-item"
                      key={`doc-${index}`}
                    >
                      <div className="document-content">
                        <div className="document-name">
                          {document.document_type.name}
                        </div>
                        <div className="document-actions">
                          <div className="file-info">
                            <img
                              src={pdfIMG}
                              className="img-fluid"
                              width="25"
                              alt="PDF"
                            />
                            <span className="file-name">
                              {document.original_filename}
                            </span>
                          </div>
                          <button
                            className="doc-btn border-0 bg-transparent"
                            onClick={() => downloadDocument(document.id)}
                          >
                            <img src={downloadIMG} width="25" alt="Scarica" />
                          </button>
                        </div>
                      </div>
                      <div className="document-status">
                        {document.signable_document === 1
                          && document.is_signed_valid ? (
                            <span className="status-badge status-success">
                              Firmato
                            </span>
                          ) : (
                            <span className="status-badge status-info">
                              Non Richiede Firma
                            </span>
                          )}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </CompletedCard>
          )}
        </div>

        {/* After Sale Section */}
        <CompletedQuoteScreenAutoAfterSale quote={quote} document_types={document_types} v2 />
      </CommercialCompletedScreenStyles>
    </>
  );
}

export default CommercialCompletedScreen;
